import React, { Component } from 'react'

import './snippet.css';

class Snippet extends Component {
    constructor(props) {
        super(props);
        this.url = 0;
        this.id = 0;
    }

    getTitleInterpret(url) {
        const elements=  url.split('/');
        const split_name = elements[3].split('.')
        var dict = {
            all_of_me_pluspunkt: ["All of me", "John Legend"],
            bergwerk_pluspunkt: ["Bergwerk", "Rainhard Fendrich"],
            billie_jean_pluspunkt: ["Billie Jean", "Michael Jackson"],
            i_need_a_dollar_pluspunkt: ["I need a Dollar", "Aloe Blacc"],
            jailhouse_rock_pluspunkt: ["Jailhouse Rock", "Elvis Presley"],
            jolene_pluspunkt: ["Jolene", "The BossHoss"],
            sei_auf_dieser_welt_willkommen_pluspunkt: ["Sei auf dieser Welt willkommen", "asdfasdf"],
            teenage_dirtbag_pluspunkt: ["Teenage Dirtbag", "Wheatus"]
        };
        const raw_name = split_name[0];
        const title = raw_name in dict ? dict[raw_name][0] : "undefined for " + url
        const interpret = raw_name in dict ? dict[raw_name][1] : "undefined for " + url
        return (<span className="titleWrap"><span className="title">{title}</span><span className="interpret">{interpret}</span></span>)
    }

    render() {
        return (
            // <div>{this.props.id} {this.props.url} </div>
            <div className="Snippet-wrapper" key={"snippet-" +this.props.id} id={this.props.id}>
                {this.props.id > 0 ? <div className="spacer"></div> : ""}
                <div className="Snippet-flex">
                    {this.getTitleInterpret(this.props.url)}
                    <li><audio controls preload="auto" autobuffer="true"><source src={this.props.url}/>Your browser does not support the audio element.</audio></li>
                </div>
            </div>
        )
    }
}

export default Snippet;



// WEBPACK FOOTER //
// ./src/mainpage-body/snippet.js